module.exports = __webpack_public_path__ + "static/media/gtb.5807a95d.svg";